<template>
	<div class="Real-timeinfoTowTop">
		<div class="widthFixed">
			<div class="top">
				<div class="leftTitle">
					资讯发布
				</div>
				<div class="rightTitle" @click="rightTitleClick">
					查看全部 <img src="@/assets/channel/login/info.png" alt="">
				</div>
			</div>

			<div class="textList" v-if="InformationArr">
				<div class="list" v-for="(item , index) of InformationArr" :key="index"
					@click="SeeInfoHome(item.InfoID,item)">
					<div class="ContextTitle">
						<div class="Topping" v-if="item.IsTOP == 1">
							置顶
						</div>
						{{item.Title}}
					</div>
					<div class="Time">
						{{item.CreateTime}}
					</div>
				</div>
			</div>
			<div class="IDefaultPageStyle" v-if="InformationArr.length == 0">
				<img src="@/assets/DefaultPage/IDefaultPageHome.png" alt="" width="320px" height="240px">
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			InformationArr: {
				type: Array
			}
		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			rightTitleClick() {
				this.$router.push({
					path: JSON.parse(localStorage.getItem("MenusData")).CusWebMenus.filter(item => item.NodeID ==
						66)[0].Path,
					query: {
						type: ''
					}
				})
			},
			SeeInfoHome(infoID, e) {
				if (e.IsOuterLink == 1) {
					window.open(e.OuterLinkUrl);
				} else {
					this.$router.push({
						path: JSON.parse(localStorage.getItem("MenusData")).CusWebMenus.filter(item => item
							.NodeID ==
							66)[0].Path,
						query: {
							type: 'Home',
							infoID: infoID
						}
					})
				}
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.Real-timeinfoTowTop {
		width: 382px;
		height: 320px;
		background: #ffffff;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: -8px;
		box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.07999999821186066);
		border-radius: 0px 0px 0px 0px;

		.widthFixed {
			position: relative;

			.IDefaultPageStyle {
				margin-left: 35px;
				margin-top: 0px;

				img {
					// width: 220px;
					// height: 220px;
				}
			}

			.top {
				width: 100%;
				margin-left: 16px;
				margin-top: 10px;
				width: 90%;
				height: 38px;
				line-height: 34px;
				border-bottom: 1px solid #e5e5e5;
				display: flex;
				justify-content: space-between;

				.leftTitle {
					font-size: 20px;
					font-weight: bold;
					color: #16181a;
				}

				.rightTitle {
					margin-top: 2px;
					margin-left: 20px;
					font-weight: normal;
					color: #424e66;
					text-decoration: none;
					cursor: pointer;

					img {
						vertical-align: middle;
						width: 16px;
						height: 16px;
					}
				}
			}

			.textList {
				width: 89%;
				max-height: 250px;
				margin-left: 17px;
				margin-top: 16px;
				border-left: 2px solid #e5e5e5;
				// border: 1px solid red;
				position: relative;

				.list {
					width: 100%;
					// height: 50px;
					// border: 1px solid rebeccapurple;
					position: relative;
					padding-bottom: 30px;
					position: relative;
					cursor: pointer;

					&:hover {
						.ContextTitle {
							color: #e71d43;
						}
					}

					.ContextTitle {
						width: 100%;
						font-size: 14px;
						font-weight: normal;
						color: #191919;
						margin-top: 2px;
						margin-left: 20px;

						.Topping {
							width: 224px;
							height: 22px;
							font-weight: normal;
							color: #fff;
							text-align: center;
							font-size: 12px;
							line-height: 16px;
							width: 32px;
							height: 16px;
							background: #e71d43;
							border-radius: 1px 1px 1px 1px;
							margin-left: 0px;
							margin-top: 5px;
							display: inline-block;
						}
					}

					.Time {
						// width: 82px;
						height: 20px;
						font-size: 12px;
						font-weight: normal;
						color: #9ca5b8;
						line-height: 20px;
						margin-left: 20px;
						margin-top: 5px;
					}
				}

				.list::before {
					content: "";
					position: absolute;
					left: -3.8px;
					top: 7px;
					width: 6px;
					height: 6px;
					border-radius: 50%;
					background-color: #00266d;
				}
			}
		}
	}
</style>